const COLORS = {
    chrome: {
        100: '#E6ECF0',
        150: '#D1DAE0',
        200: '#BCC8D1',
        300: '#A0B0BD',
        350: '#8C9FAD',
        400: '#788E9E',
        450: '#6C808F',
        500: '#607280',
        550: '#505E69',
        600: '#404A52',
        650: '#383F45',
        700: '#303438',
        800: '#19191A',
    },
    red: {
        high: '#FFBA8F',
        light: '#FC8E62',
        normal: '#F5523A',
        dark: '#CC2D32',
        toxic: '#FA3E2C',
    },
    cinnabar: {
        high: '#FFC690',
        light: '#FCA062',
        normal: '#FA6A3C',
        dark: '#D4412E',
        toxic: '#FC5230',
    },
    orange: {
        high: '#FCD45F',
        light: '#FCBC3A',
        normal: '#FA9214',
        dark: '#D46408',
        toxic: '#FC9000',
    },
    amber: {
        high: '#FCE45E',
        light: '#FCDA30',
        normal: '#FAC220',
        dark: '#DC9212',
        toxic: '#FCB900',
    },
    yellow: {
        high: '#FAF67D',
        light: '#FAF055',
        normal: '#FAE436',
        dark: '#E6BC26',
        toxic: '#FCE000',
    },
    lime: {
        high: '#C0F266',
        light: '#9AE63C',
        normal: '#5AC31A',
        dark: '#239808',
        toxic: '#48C600',
    },
    green: {
        high: '#8AF284',
        light: '#48E65F',
        normal: '#1CC052',
        dark: '#029154',
        toxic: '#00CA50',
    },
    blue: {
        high: '#80D8F8',
        light: '#42C6FA',
        normal: '#169CDC',
        dark: '#0668BE',
        toxic: '#0596FA',
    },
    shamelessBlue: {
        high: '#9DC3FC',
        light: '#739EFA',
        normal: '#4060E3',
        dark: '#2041B0',
        toxic: '#324CF0',
    },
    purple: {
        high: '#EBB6FA',
        light: '#DE86FA',
        normal: '#C044F2',
        dark: '#8822D0',
        toxic: '#C81EFA',
    },
    warmGray: {
        50: '#FAF9F7',
        75: '#F8F7F5',
        100: '#F5F4F2',
        125: '#F1F0ED',
        150: '#EDECE8',
        175: '#E7E5E1',
        200: '#E0DEDA',
        225: '#D2D0CC',
        250: '#C4C2BE',
        300: '#9E9B98',
        350: '#8A8784',
        400: '#75736F',
        450: '#5C5A57',
        500: '#42413E',
        550: '#302F2D',
        600: '#21201F',
    },
    coldGray: {
        50: '#F7F9FA',
        75: '#F4F6F7',
        100: '#F2F4F5',
        125: '#EDF0F1',
        150: '#E8EBED',
        175: '#E2E4E7',
        200: '#DCDEE0',
        225: '#CDD0D2',
        250: '#BEC1C4',
        300: '#999C9E',
        350: '#84878A',
        400: '#717375',
        450: '#57595C',
        500: '#3F4042',
        550: '#2E2E30',
        600: '#1F2021',
    },
    coldYellowPastel: {
        50: '#F9F7F2',
        75: '#F5F2EB',
        100: '#F3F0E7',
        125: '#EBE7DA',
        150: '#E4E0D2',
        175: '#DDD9CA',
        200: '#CECABB',
        225: '#C0BCAC',
        250: '#999588',
        300: '#848076',
        350: '#6E6C63',
        400: '#56544D',
        450: '#3D3C37',
        500: '#2C2B2A',
        550: '#1E1D1D',
    },
    absolute: {
        white: '#FFFFFF',
        black: '#000000',
    },
};
const DEFAULT_UNITS = {
    xs: 4,
    s: 8,
    m: 16,
    l: 24,
    xl: 32,
};
const FONTS = {
    sizes: {
        header: 48,
        title1: 40,
        title2: 32,
        title3: 28,
        title4: 24,
        body1: 20,
        body2: 16,
        caption1: 13,
        caption2: 11,
    },
    weights: {
        light: '300',
        regular: '400',
        medium: '500',
        bold: '700',
    },
    heights: {
        header: {
            tight: 40,
            normal: 46,
            loose: 50,
        },
        title1: {
            tight: 34,
            normal: 42,
            loose: 44,
        },
        title2: {
            tight: 28,
            normal: 35,
            loose: 37,
        },
        title3: {
            tight: 24,
            normal: 31,
            loose: 34,
        },
        title4: {
            tight: 21,
            normal: 27,
            loose: 30,
        },
        body1: {
            tight: 20,
            normal: 23,
            loose: 26,
        },
        body2: {
            tight: 17,
            normal: 19,
            loose: 21,
        },
        caption1: {
            tight: 14,
            normal: 15,
            loose: 17,
        },
        caption2: {
            tight: 12,
            normal: 13,
            loose: 15,
        },
    },
    spacings: {
        header: {
            light: '-0.03em',
            regular: '-0.03em',
            medium: '-0.02em',
            bold: '-0.02em',
        },
        title1: {
            light: '-0.025em',
            regular: '-0.025em',
            medium: '-0.02em',
            bold: '-0.02em',
        },
        title2: {
            light: '-0.025em',
            regular: '-0.025em',
            medium: '-0.02em',
            bold: '-0.02em',
        },
        title3: {
            light: '-0.015em',
            regular: '-0.015em',
            medium: '-0.015em',
            bold: '-0.015em',
        },
        title4: {
            light: '-0.01em',
            regular: '-0.01em',
            medium: '-0.01em',
            bold: '-0.01em',
        },
        body1: {
            light: '-0.01em',
            regular: '-0.01em',
            medium: '-0.01em',
            bold: '-0.01em',
        },
        body2: {
            light: 'normal',
            regular: 'normal',
            medium: '-0.005em',
            bold: '-0.005em',
        },
        caption1: {
            light: 'normal',
            regular: 'normal',
            medium: 'normal',
            bold: 'normal',
        },
        caption2: {
            light: '0.01em',
            regular: '0.01em',
            medium: '0.01em',
            bold: '0.01em',
        },
    },
};
export function createTheme(fabric) {
    return fabric({ spacingUnits: DEFAULT_UNITS, colors: COLORS, fonts: FONTS });
}
